
import { unitsdata } from "../json/unitsdata";
import { invoicelistdata } from "../json/invoicelistdata";
import { CustomerData } from "../json/customer_data";
import { ShopData } from "../json/shop_data";
import { SupplierData } from "../json/supplier_data";
import { ManageStocksdata } from "../json/managestocks_data";
import { StockTransferData } from "../json/stocktransferdata";
import { userlisadata } from "../json/users";
import { rolesandpermission } from "../json/rolesandpermissiondata";
import { categorylist } from "../json/categorylistdata";
import { subcateorydata } from "../json/subcategorydata";
const { inventoryproductsdata } = require("../json/inventoryproductsdata");

const initialState = {
  inventory_list: inventoryproductsdata,
  unit_data: unitsdata,
  toggle_header: false,
  invoicereport_data: invoicelistdata,
  customerdata: CustomerData,
  shopdata : ShopData,
  supplierdata: SupplierData,
  managestockdata: ManageStocksdata,
  stocktransferdata: StockTransferData,
  userlist_data: userlisadata,
  rolesandpermission_data: rolesandpermission,
  categotylist_data: categorylist,
  subcategory_data: subcateorydata,

  layoutstyledata: localStorage.getItem("layoutStyling"),
};

export default initialState;
